module.exports = __webpack_public_path__ + "278cfd224f31de0d2bd0a0f4a2f7d3ab.jpg";